import { render, staticRenderFns } from "./IPContact.vue?vue&type=template&id=62acf31f"
import script from "./IPContact.vue?vue&type=script&lang=js"
export * from "./IPContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports